import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table, Radio, 
    Space, Empty, Popconfirm, Modal, Cascader, Checkbox, Tooltip, Tag
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateKernelExtension, putTemplateKernelExtension, 
    batchUpdateKernelExtension, deleteKernelExtensionList, deleteKernelExtension
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentKernelExtension = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<any>([]);
    const [allowIsTrue, setAllowIsTrue] = useState<boolean>(false);
    const [allowNonAdmin, setAllowNonAdmin] = useState<boolean>(false);
    const [extensionModalVisible, setExtensionModalVisible] = useState<boolean>(false);
    const [isEditExtension, setIsEditExtension] = useState<boolean>(false);
    const [selectedExtensionId, setSelectedExtensionId] = useState<string>("");
    const [isDisable, setIsDisable] = useState<boolean>(false);
    const [dataForm] = Form.useForm();

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = async () => {
        setShowTable(1)
        await getTemplateKernelExtension(templateId).then((res) => {
            if (res.length > 0) {
                setAllowIsTrue(res[0]?.allowUserOverrides);
                setAllowNonAdmin(res[0]?.allowNonAdminUserApprovals);
                setShowTable(2);
                setData(res);
                // setTimeout(() => {
                // }, 500);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            var params: any = {}
            res.packageList = res.packageList ? res.packageList.filter((item: any) => item) : [];
            params = res;
            params["allowUserOverrides"] = allowIsTrue;
            params["allowNonAdminUserApprovals"] = allowNonAdmin;
            params["id"] = selectedExtensionId;
            
            putTemplateKernelExtension(templateId, params).then(() => {
                updateTemplate();
                notification.success({ message: t("操作成功") });
                dataForm.resetFields();
                setExtensionModalVisible(false);
                setSelectedExtensionId("");
                getDataInfo();
            })
        })
    }

    const removeSystemExtension = (id: string) => {
        deleteKernelExtension(templateId, id).then(() => {
            notification.success({ message: t("操作成功") });
            if (data.length === 1) {
                setData([]);
                updateTemplate();
            }
            getDataInfo();
        })
    }

    const deleteTemplateClick = () => {
        deleteKernelExtensionList(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            setData([]);
            getDataInfo();
        })
    }

    const addExtension = () => {
        dataForm.resetFields();
        setIsEditExtension(false);
        setExtensionModalVisible(true);
    }

    const editExtension = (row: any) => {
        dataForm.setFieldsValue(row)
        setSelectedExtensionId(row.id);
        setIsEditExtension(true);
        setExtensionModalVisible(true);
    }

    const batchUpdate = () => {
        if (data.length === 0) {
            notification.warning({message: t("请先添加扩展")})
        } else {
            batchUpdateKernelExtension(templateId, allowIsTrue, allowNonAdmin).then(() => {
                setAllowIsTrue(allowIsTrue);
                setAllowNonAdmin(allowNonAdmin)
                updateTemplate();
                getDataInfo();
                notification.success({ message: t("操作成功") });
            })
        }
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("Kernel Extension")}</Col>
                <Col style={{ marginLeft: 36 }}>
                    <Tooltip title={t("可在macOS 10.13.2及更高版本中使用")}>
                        <Tag color="cyan">macOS 10.13.2+</Tag>
                    </Tooltip>
                </Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>{t("配置内核扩展，此操作可能威胁操作系统的完整性和可靠性，推荐使用系统扩展。")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button disabled={isDisable} onClick={() => { addClick() }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <div className="tAr" style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
                            <Space direction="vertical">
                                <Space>
                                    <span style={{color: "#ff4d4f", lineHeight: 1}}>*</span>
                                    <span>{t("允许用户手动批准内核扩展")}: </span>
                                    <Radio.Group defaultValue={allowIsTrue} onChange={(e) => { setAllowIsTrue(e.target.value) }}>
                                        <Radio value={true}>{t("是")}</Radio>
                                        <Radio value={false}>{t("否")}</Radio>
                                    </Radio.Group>
                                </Space>
                                <Space>
                                    <span style={{color: "#ff4d4f", lineHeight: 1}}>*</span>
                                    <span>{t("允许非管理员用户批准")}: </span>
                                    <Radio.Group defaultValue={allowNonAdmin} onChange={(e) => { setAllowNonAdmin(e.target.value) }}>
                                        <Radio value={true}>{t("是")}</Radio>
                                        <Radio value={false}>{t("否")}</Radio>
                                    </Radio.Group>
                                </Space>
                            </Space>
                            <Button type="primary" onClick={ addExtension }><PlusOutlined />{t("添加内核扩展")}</Button>
                        </div>
                        <Table 
                            dataSource={data} 
                            rowKey="id"
                            style={{ width: "100%" ,marginLeft:8}}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Table.Column
                                title={t("团队标识符")}
                                key="teamIdentifier"
                                dataIndex="teamIdentifier"
                            ></Table.Column>
                            <Table.Column
                                title={t("程序包标识")}
                                key="packageList"
                                dataIndex="packageList"
                                render={(value) => value?.join(";")}
                            ></Table.Column>
                            <Table.Column
                                title={t("操作")}
                                key="id"
                                dataIndex="id"
                                render={(id, row) => {
                                    return (
                                        <Space size={8}>
                                            <Button type="link" block onClick={() => { editExtension(row) }}>{t("编辑")}
                                            </Button>
                                            <Popconfirm
                                                title={`${t("确认移除")}？`}
                                                onConfirm={() => { removeSystemExtension(id) }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Button type="link" block>{t("移除")}</Button>
                                            </Popconfirm>
                                        </Space>
                                    )
                                }}
                            ></Table.Column>
                        </Table>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { batchUpdate() }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick() }}>{t("删除规则")}</Button>
                        </div>

                        <Modal
                            confirmLoading={loading}
                            open={extensionModalVisible}
                            maskClosable={false}
                            destroyOnClose={true}
                            title={`${isEditExtension ? t("编辑内核扩展") : t("添加内核扩展")}`}
                            forceRender={true}
                            onOk={() => { addTemplateClick() }}
                            onCancel={() => { setExtensionModalVisible(false); dataForm.resetFields(); setSelectedExtensionId("") }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                form={dataForm}
                                layout="vertical"
                            >
                                <Form.Item label={t("团队标识符")} name="teamIdentifier" rules={[{required: true}]}>
                                    <Input></Input>
                                </Form.Item>
                                <Form.List name="packageList">
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map((field) => (
                                                <Form.Item key={field.key} label={t("程序包标识")}>
                                                    <Row justify="space-between">
                                                        <Col span="21">
                                                            <Form.Item noStyle
                                                                {...field}
                                                                name={[field.name]}
                                                                // fieldKey={[field.fieldKey]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Button type="dashed" onClick={() => { remove(field.name) }}>-</Button>
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                            ))}
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => { add() }} block>
                                                    <PlusOutlined />{t("程序包标识")}
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                                
                            </Form>
                        </Modal>
                    </>
                )}
            </Row>
        </div>
    </>);
};